import { render, staticRenderFns } from "./DashboardAll.vue?vue&type=template&id=04358146"
import script from "./DashboardAll.vue?vue&type=script&lang=js"
export * from "./DashboardAll.vue?vue&type=script&lang=js"
import style0 from "./DashboardAll.vue?vue&type=style&index=0&id=04358146&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports